import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';

const useFetchRequestQueries = (fetch, category, code, cohortCode, readStatus) => {
  useEffect(() => {
    if (readStatus === states.NONE) {
      fetch(category, code, cohortCode, []);
    }
  }, [category, code, cohortCode, readStatus]);
};

export default {
  useFetchRequestQueries,
};
